// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"f9c2f424","107":"010e87c4","135":"7e4848f9","229":"77c0cda0","253":"6027e033","402":"d6fb2b6e","457":"2a7c6fe6","464":"f0d07c48","679":"7e756035","716":"43de1fd0","920":"f2ebfbae"}[chunkId] + ".chunk.js";
};